import { useContractCategoryDetailsContext } from '../../Providers/ContractCategoryDetailsContextProvider'
import { FieldWithLabel } from '../../../../components/FieldWithLabel/FieldWithLabel'
import { LABELS } from '../../../../constants'
import { LeadByIndicator } from '../../../../components/LeadByIndicator'
import { Typography } from '../../../../components/Typography'
import { LED_BY_VALUE } from '../../../../components/LeadByIndicator/constants'

export const AdditionalInfo = () => {
  const { state } = useContractCategoryDetailsContext()
  const { details } = state

  return (
    <div className="contract-category-details-general__details__grid column full-width">
      <FieldWithLabel title={LABELS.LED_BY} className="led-by-field">
        <div className="row gap-8">
          <LeadByIndicator value={details.led_by} />
          <Typography.Body1>
            {details.led_by === LED_BY_VALUE.OM_LIFELINE
              ? 'OM Lifeline'
              : details.contract_category_organization_name}
          </Typography.Body1>
        </div>
      </FieldWithLabel>
      <FieldWithLabel title={LABELS.PORTFOLIO} className="mt-16">
        <Typography.Body1>{details.portfolio?.name}</Typography.Body1>
      </FieldWithLabel>
    </div>
  )
}
